import React from 'react';
import Hyperlink from '../../../../components/atoms/Hyperlink/Hyperlink';
import ILink from '../../../../types/ILink';

export type Keyword = ILink;
export type KeywordProps = { keyword: Keyword };

export function Keyword({ keyword }: KeywordProps) {
  return (
    <Hyperlink className="keywords__text keywords__text--link font-regular-13-13" to={keyword.url}>
      {keyword.name}
    </Hyperlink>
  );
}
